import styled from 'styled-components';
import { Button } from '@adobe/react-spectrum';

import Input from '../../components/Forms/Input';

export const Wrap = styled.div`
  display: grid;
  grid-template-columns: 73% 25%;

  .wrapper-class {
    display: flex;
    flex-direction: column-reverse;
  }

  .editor-class {
    overflow: hidden;
    width: 751px;
    height: 100%;
    padding: 1rem;
    border: 1px solid #ccc;
    border-radius: 5px 5px 0 0;
  }

  .toolbar-class {
    width: 739px;
    border: 1px solid #ccc;
    border-radius: 0 0 5px 5px;
  }
`;

export const Overview = styled(Input)``;

export const Description = styled(Input).attrs(() => ({
  marginTop: '25px',
}))``;

export const LaunchDateTime = styled.div`
  display: flex;
`;
export const Section = styled.div`
  display: flex;
`;
export const CompletionDateTime = styled.div`
  display: flex;
`;

export const RightHandsideAligner = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ExistingBriefs = styled.div`
  width: 100%;
  height: 80px;
  margin-top: 25px;
  margin-left: -3px;
  background-color: white;
  cursor: pointer;
`;

export const Actions = styled.div`
  position: relative;
  width: 100%;
  margin-top: 10px;
`;

export const Submit = styled(Button)``;

export const EditorWrapper = styled.div`
  border-bottom: 1px solid lightgray;
  margin-bottom: 25px;
  padding-bottom: 20px;
`;

export const EditorHeaderText = styled.div`
  margin-top: 25px;
  margin-bottom: 5px;
  font-size: 12px;
`;
